import cuid from 'cuid'
import api from '@disco/api/server'
import { TRACK } from '@disco/constants/ItemTypes'
import { getExtension } from '@disco/utils/file-utils'
import type { StandardProviderFile, UploadProvider } from 'types/upload'
const provider: UploadProvider = {
  id: 'box',
  title: 'Box',

  async upload(shortlistId, uploadId, tempItems) {
    await api.uploadProviderFiles(provider.id, shortlistId, uploadId, tempItems)
  },

  prepareTempItems(files: StandardProviderFile[]) {
    return files.map(file => ({
      tempId: cuid(),
      filename: file.name,
      title: file.name,
      album: undefined,
      artist: undefined,
      ext: getExtension(file.name),
      progress: 0,
      type: TRACK,
      groups: [],
      // Reference to the original file object to send to the server
      file: file,
      // Stored here so we can generically verify the file size
      size: file.size,
      // URL to the file
      url: file.url,
    }))
  },
}
export default provider
